import { RequiredPermissionParams } from './srnGenerator'

/**
 * @TODO
 * I dont think this PermissionAction enum is a good approach, as everytime new action occurs we have to update this lib,
 * and even for very local cases which does not affect global usage. eg:
 * "logging:orders:general" which is used locally not needed be part of this enum action.
 *
 * PLUS: it would good to have a TS system in place
 * which will not allow something like this: logging:orders:send_signature
 */
export enum PermissionAction {
  ADD = 'add',
  EDIT = 'edit',
  REMOVE = 'remove',
  VIEW = 'view',
  ARCHIVE = 'archive',
  HISTORY = 'history',
  MANAGE = 'manage',
  NONE = 'none',
  GENERAL = 'general',
  MEDICATION = 'medication',
  VIEW_ALL_SURVEYOR = 'view_surveyor',
  LIST = 'list',
  ASSIGN = 'assign',
  IGNORE = 'ignore',
  SEND_SIGNATURE_REQUEST = 'send_signature_request',
  SIGN = 'sign',
  VIEW_STATS = 'view_stats',
  ADD_ITEM = 'add_item',
}

interface ParsedPermission {
  module: string
  resourceType: string
  action: PermissionAction
}

export const SRN_PARTS_DIVIDER = ':'
export type InternalPermissionActions = 'view_all'

export const parsePermission = (permission: string): ParsedPermission => {
  const [module, resourceType, action] = permission.split(SRN_PARTS_DIVIDER)

  return {
    module: module || '',
    resourceType: resourceType || '',
    action: (action as PermissionAction) || PermissionAction.NONE,
  }
}

// Parse whole srn in format created by generateSrn e.g. srn:v1:20:logging:log:386023
export const parseSrn = (srn: string) => {
  const [, srnVersion, clinicId, ...rest] = srn.split(SRN_PARTS_DIVIDER)
  const parsedPermission = parsePermission(rest.join(SRN_PARTS_DIVIDER))
  return {
    ...parsedPermission,
    srnVersion,
    clinicId,
  }
}

export const getPermission = ({
  module,
  resourceType,
  permissionResourceType,
  action,
}: RequiredPermissionParams): string =>
  [module, permissionResourceType ?? resourceType, action].join(
    SRN_PARTS_DIVIDER,
  )
